import { Box, Typography } from "@mui/material"

const PredictionHeading = ({ title = "Predictions"}) => {
  return (
    <Box sx={{ mb: 2, ml: 2 }}>
            <Typography
                variant="h6"
                sx={{
                    fontWeight: "bold",
                    mb: 1.5,
                    fontSize: "1.1rem",
                    color: "primary.main",
                }}
            >
                {title}
            </Typography>
    </Box>
  )
}

export default PredictionHeading
